<template>
<div id="app">
  <component :is="layout">
  <router-view/>
  </component>
</div>

</template>
<script>
export default {
	computed: {
		layout () {
			return (this.$route.meta.layout || this.default_layout) + '-layout'
		}
	},
	data () {
		return {
			default_layout: 'Default'
		}
	}

}
</script>



// WEBPACK FOOTER //
// src/App.vue